import {
  AutocompleteGenericEntity,
  DOMAIN_CODE_LABELS,
} from '@australiangreens/ag-internal-components';

// In this case the ids are the domain codes
export const DOMAINS_WITH_IDS: AutocompleteGenericEntity[] = Object.entries(DOMAIN_CODE_LABELS)
  .toSorted()
  .map(([code, label]) => ({ id: code, label }));
